export function DesignSkeleton() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-100">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-zinc-300 border-t-zinc-600" />
        <p className="text-sm text-zinc-400">Loading...</p>
      </div>
    </div>
  );
}
